import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "5:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-450.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "5:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-450.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "5:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-450.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "5:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-450.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "5:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-450.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
